import {
	ROUTES_CLEAR_API_ROUTES,
	ROUTES_CLEAR_CLIENT_ROUTES,
	ROUTES_FETCH_API_ROUTES,
	ROUTES_FETCH_CLIENT_ROUTES,
	ROUTES_SET_API_ROUTES,
	ROUTES_SET_CLIENT_ROUTES
} from './constants';
import {IApiRoute as IApiRouteDB, IClientRoute as IClientRouteDB} from '../../@interfaces/services/Database';

export const fetchApiRoutes = () => ({type: ROUTES_FETCH_API_ROUTES});
export const setApiRoutes = (routes: IApiRouteDB[]) => ({type: ROUTES_SET_API_ROUTES, payload: routes});
export const clearApiRoutes = () => ({type: ROUTES_CLEAR_API_ROUTES});

export const fetchClientRoutes = () => ({type: ROUTES_FETCH_CLIENT_ROUTES});
export const setClientRoutes = (routes: IClientRouteDB[]) => ({type: ROUTES_SET_CLIENT_ROUTES, payload: routes});
export const clearClientRoutes = () => ({type: ROUTES_CLEAR_CLIENT_ROUTES});
